var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('label',{class:_vm.screenReaderLabelClass},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('input',_vm._b({class:_vm.inputClass,domProps:{"value":_vm.value},on:{"input":_vm.updateValue}},'input',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }